export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export function isEmptyGuid(value) {
  return !value || value === EMPTY_GUID;
}

/**
 * Resolve the application user id from login / switch-organization userInfo payloads.
 * Supports camelCase and legacy PascalCase keys.
 */
export function resolveApplicationUserIdFromUserInfo(userInfo) {
  if (!userInfo) return null;

  const raw =
    userInfo.applicationUserId ||
    userInfo.ApplicationUserId ||
    userInfo.applicationUserProfile?.id ||
    userInfo.applicationUserProfile?.Id;

  return isEmptyGuid(raw) ? null : raw;
}

/**
 * Merge an organisation switch response into the stored user session without
 * wiping identity-scoped fields when the API returns empty defaults.
 */
export function mergeOrganizationSwitchUserInfo(existingUserInfo, switchResponse) {
  const switchedId = resolveApplicationUserIdFromUserInfo(switchResponse);
  const existingId = resolveApplicationUserIdFromUserInfo(existingUserInfo);
  const applicationUserId = switchedId || existingId || '';

  const switchedProfile = switchResponse?.applicationUserProfile;
  const existingProfile = existingUserInfo?.applicationUserProfile;
  const hasSwitchedProfile = switchedProfile?.id && !isEmptyGuid(switchedProfile.id);
  const applicationUserProfile = hasSwitchedProfile
    ? switchedProfile
    : (existingProfile?.id && !isEmptyGuid(existingProfile.id))
      ? existingProfile
      : switchedProfile ?? existingProfile;

  return {
    ...existingUserInfo,
    ...switchResponse,
    businessOrganisationId: switchResponse.businessOrganisationId,
    businessOrganisationName: switchResponse.businessOrganisationName,
    businessOrganisationIdentifier: switchResponse.businessOrganisationIdentifier,
    token: switchResponse.token,
    refreshToken: switchResponse.refreshToken,
    applicationUserId,
    applicationUserProfile,
  };
}
